// The `dev` configuration in angular.json swaps environment.ts for this one.
export const environment = {
  envName: 'dev',
  baseUrl: 'https://dev.api.salonfriday.com',
  userKey: "userKey",
  refreshTokenExpMinutes: 5
};
